import cn from "classnames";
import { GroupedCarSelect } from "components/shared/form";
import Select, { customFilterSelectStyles, defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import debounce from "lodash/debounce";
import React, { useCallback, useState } from "react";
import { namesList as counterpartyList } from "sources/books/cargoOwners";
import { namesList } from "sources/books/drivers";
import { listSalesManagers, list as logistsList } from "sources/books/employees";
import { list as trailersList } from "sources/books/trailers";
import { numbersList as trucksList } from "sources/books/trucks";

export default function Filter(props) {
    const { setFilter, setMultipleFilters, resetFilters, filters } = props;
    const [filtersOpened, setFiltersOpened] = useState(false);
    const [bidIds, setBidIds] = useState(filters.bidIds);

    const resetAllFilters = (e) => {
        e.stopPropagation();
        setBidIds("");
        resetFilters();
    };

    const onBidIdChange = useCallback(
        debounce((value) => setFilter({ name: "bidIds", value: value || undefined }), 300),
        [],
    );

    const hasFilters = Object.keys(filters).length > 0;

    const refreshData = (e) => {
        e.stopPropagation();
        props.refreshData();
    };

    const selectProps = {
        ...defaultMultipleSelectProps,
        styles: { ...customFilterSelectStyles },
        components: { ValueContainer },
    };

    const expandCname = cn("b-filter__collapse-btn", {
        "b-filter__collapse-btn--top": filtersOpened,
        "b-filter__collapse-btn--bottom": !filtersOpened,
    });
    const headerTextCname = cn("b-filter__search-text", { "b-filter__search-text--dark": filtersOpened });

    return (
        <div className="b-filter">
            <div className="b-filter__head" onClick={() => setFiltersOpened(!filtersOpened)}>
                <div className="b-filter__head--left">
                    {!filtersOpened && <div className="b-filter__filter-icon" />}
                    <div className={headerTextCname}>Фильтры</div>
                </div>
                <div className="b-filter__head--right">
                    {!filtersOpened && (
                        <>
                            {hasFilters && (
                                <div className="b-filter__btn b-filter__btn--reset" onClick={resetAllFilters}>
                                    Сбросить
                                </div>
                            )}
                            <div className="b-filter__btn b-filter__btn--refresh" onClick={refreshData}>
                                Обновить
                            </div>
                        </>
                    )}
                    <div className={expandCname} />
                </div>
            </div>
            {filtersOpened && (
                <>
                    <div className="b-filter__body">
                        <div className="b-filter__body-column">
                            <div className="pb-1">
                                <input
                                    className="b-filter__input"
                                    placeholder="ID заявки"
                                    value={bidIds}
                                    name="id"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setBidIds(value);
                                        onBidIdChange(value);
                                    }}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "logistIds" }}
                                    url={logistsList}
                                    placeholder="По логисту"
                                    onChange={setFilter}
                                    propName="fullNameOrEmail"
                                    value={filters.logistIds}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "responsibleIds" }}
                                    url={logistsList}
                                    placeholder="По ответственному"
                                    onChange={setFilter}
                                    propName="fullNameOrEmail"
                                    value={filters.responsibleIds}
                                />
                            </div>
                        </div>
                        <div className="b-filter__body-column">
                            <div className="pb-1">
                                <GroupedCarSelect
                                    inputProps={{ name: "car" }}
                                    propName="number"
                                    url={trucksList}
                                    placeholder={
                                        <div className="ellipsis" title="Номер машины или колонна">
                                            Номер машины или колонна
                                        </div>
                                    }
                                    dataIndex={filters.transportColumnIds?.length > 0 ? "transportColumnId" : "id"}
                                    value={filters.transportColumnIds ?? filters.carIds}
                                    values={{
                                        transportColumn: filters.transportColumnIds ?? null,
                                        car: filters.carIds ?? null,
                                    }}
                                    onChange={setMultipleFilters}
                                    styles={{ ...customFilterSelectStyles }}
                                    {...defaultMultipleSelectProps}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "trailerIds" }}
                                    url={trailersList}
                                    placeholder="По прицепу"
                                    onChange={setFilter}
                                    propName="number"
                                    value={filters.trailerIds}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "driverIds" }}
                                    url={namesList}
                                    filterPropName="fullName"
                                    propName="fullName"
                                    placeholder="По водителю"
                                    onChange={setFilter}
                                    value={filters.driverIds}
                                />
                            </div>
                        </div>
                        <div className="b-filter__body-column">
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "counterpartyIds" }}
                                    url={counterpartyList}
                                    placeholder="По контрагенту"
                                    onChange={setFilter}
                                    propName="name"
                                    value={filters.counterpartyIds}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "excludeCounterpartyIds" }}
                                    url={counterpartyList}
                                    placeholder="Исключить контрагента"
                                    onChange={setFilter}
                                    propName="name"
                                    value={filters.excludeCounterpartyIds}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "salesManagerIds" }}
                                    url={listSalesManagers}
                                    placeholder="По менеджеру по продажам"
                                    onChange={setFilter}
                                    propName="fullNameOrEmail"
                                    value={filters.salesManagerIds}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="b-filter__footer pt-2">
                        {hasFilters && (
                            <div className="b-filter__btn b-filter__btn--reset" onClick={resetFilters}>
                                Сбросить
                            </div>
                        )}
                        <div className="b-filter__btn b-filter__btn--refresh" onClick={refreshData}>
                            Обновить
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
